import { render, staticRenderFns } from "./projectCodeEditor.vue?vue&type=template&id=b73d6d08"
import script from "./projectCodeEditor.vue?vue&type=script&lang=js"
export * from "./projectCodeEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports